import { ArrowTopRightOnSquareIcon } from "@heroicons/react/20/solid";
import { getTxBlockExplorerLink } from "common";
import { truncateAddress } from "../../utils/address";
import { MintingActionButton } from "../Buttons";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TransactionHeader(_ref) {
  let {
    transactionHash,
    transactionChainId,
    contributions = [],
    attestationData: {
      attestation,
      isFetchingAttestations,
      refetch
    }
  } = _ref;
  const transactionLink = getTxBlockExplorerLink(transactionChainId, transactionHash);
  const parcialTransactionHash = truncateAddress(transactionHash, 5);
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-grey-75 rounded-lg gap-2 p-4 flex flex-col sm:flex-row items-center justify-between",
    children: [/*#__PURE__*/_jsx("span", {
      className: "font-medium font-mono text-base/[26px] whitespace-nowrap",
      children: /*#__PURE__*/_jsxs("a", {
        className: "flex items-center gap-[11px]",
        target: "_blank",
        href: transactionLink,
        children: [`Transaction #${parcialTransactionHash}`, /*#__PURE__*/_jsx(ArrowTopRightOnSquareIcon, {
          className: "size-4 text-black"
        })]
      })
    }), /*#__PURE__*/_jsx(MintingActionButton, {
      transaction: {
        hash: transactionHash,
        chainId: transactionChainId
      },
      contributions: contributions,
      attestationData: {
        attestation,
        isFetchingAttestations,
        refetch
      }
    })]
  });
}